var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpaceBgTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1125 231.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:.3;stroke:#fff;}.cls-1,.cls-2{fill:none;stroke-miterlimit:10;stroke-width:5px;}.cls-3{opacity:.48;}.cls-4{fill:#d1e5e1;}.cls-5{opacity:.26;}.cls-6{opacity:.1;}.cls-2{opacity:.13;stroke:#000;}.cls-7{fill:#b4ccc7;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "New_Symbol_2",
    viewBox: "0 0 18.95 18.95"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 9.47,
    cy: 9.47,
    r: 9.47
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.47,2c4.12,0,7.47,3.35,7.47,7.47s-3.35,7.47-7.47,7.47-7.47-3.35-7.47-7.47S5.35,2,9.47,2M9.47,0C4.24,0,0,4.24,0,9.47s4.24,9.47,9.47,9.47,9.47-4.24,9.47-9.47S14.71,0,9.47,0h0Z"
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "562.5 181.4 132.05 181.4 50.16 231.62 0 231.62 0 19.08 562.5 19.08 562.5 181.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "562.5 162.32 132.05 162.32 50.16 212.54 0 212.54 0 0 562.5 0 562.5 162.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "562.5 181.4 992.95 181.4 1074.84 231.62 1125 231.62 1125 19.08 562.5 19.08 562.5 181.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "552.5 162.32 992.95 162.32 1074.84 212.54 1125 212.54 1125 0 552.5 0 552.5 162.32"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 377.54,
    y1: 0.23,
    x2: 377.54,
    y2: 162.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 372.46,
    y1: 0.23,
    x2: 372.46,
    y2: 162.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 752.54,
    y1: 0.23,
    x2: 752.54,
    y2: 162.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 747.46,
    y1: 0.23,
    x2: 747.46,
    y2: 162.3
  })), /*#__PURE__*/React.createElement("use", {
    width: 18.95,
    height: 18.95,
    transform: "translate(1098.76 4.9)",
    xlinkHref: "#New_Symbol_2"
  }), /*#__PURE__*/React.createElement("use", {
    width: 18.95,
    height: 18.95,
    transform: "translate(763.08 4.9)",
    xlinkHref: "#New_Symbol_2"
  }), /*#__PURE__*/React.createElement("use", {
    width: 18.95,
    height: 18.95,
    transform: "translate(719.16 4.9)",
    xlinkHref: "#New_Symbol_2"
  }), /*#__PURE__*/React.createElement("use", {
    width: 18.95,
    height: 18.95,
    transform: "translate(387.74 4.9)",
    xlinkHref: "#New_Symbol_2"
  }), /*#__PURE__*/React.createElement("use", {
    width: 18.95,
    height: 18.95,
    transform: "translate(344.82 4.9)",
    xlinkHref: "#New_Symbol_2"
  }), /*#__PURE__*/React.createElement("use", {
    width: 18.95,
    height: 18.95,
    transform: "translate(5.9 4.9)",
    xlinkHref: "#New_Symbol_2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceBgTop);
export default __webpack_public_path__ + "static/media/space-bg-top.ced0c28c362f428d41e6abe8ea9aef5b.svg";
export { ForwardRef as ReactComponent };